"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Signal = void 0;
var tslib_1 = require("tslib");
var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");
var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");
var ui_signal_1 = require("@hopin-team/ui-signal");
var styled_components_1 = tslib_1.__importStar(require("styled-components"));
var TopLeftPositions;
(function (TopLeftPositions) {
    TopLeftPositions[TopLeftPositions["tiny"] = 1.1] = "tiny";
    TopLeftPositions[TopLeftPositions["small"] = 1.5] = "small";
    TopLeftPositions[TopLeftPositions["medium"] = 1.9] = "medium";
    TopLeftPositions[TopLeftPositions["large"] = 2.3] = "large";
    TopLeftPositions[TopLeftPositions["huge"] = 2.8] = "huge";
    TopLeftPositions[TopLeftPositions["gigantic"] = 3.2] = "gigantic";
})(TopLeftPositions || (TopLeftPositions = {}));
var makeTopLeftPositionStyles = function (sizeOption) { return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  top: ", "rem;\n  left: ", "rem;\n"], ["\n  top: ", "rem;\n  left: ", "rem;\n"])), TopLeftPositions[sizeOption], TopLeftPositions[sizeOption]); };
exports.Signal = (0, styled_components_1.default)(ui_signal_1.Signal)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  box-shadow: 0 0 0 0.125rem\n    ", ";\n\n  ", "\n"], ["\n  position: absolute;\n  box-shadow: 0 0 0 0.125rem\n    ", ";\n\n  ", "\n"])), function (_a) {
    var theme = _a.theme;
    return (0, ui_helper_deep_branding_1.getFromTheme)("COLOR.GREY.WHITE", theme);
}, function (props) { return (0, ui_helper_props_to_styles_1.makeStyles)(props, 'sizeOption', makeTopLeftPositionStyles); });
var templateObject_1, templateObject_2;
//# sourceMappingURL=signal.js.map